import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./ServiceCard.css";

function ServiceCard({ service }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className={`service-card ${hovered ? "service-card--hovered" : ""}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() => navigate(`/services/${service.id}`)}
    >
      <div className="service-card__image-wrap">
        <img
          src={service.image}
          alt={service.title}
          className={`service-card__img ${hovered ? "service-card__img--zoom" : ""}`}
        />
        <div className="service-card__overlay" />
        <span className="service-card__icon">{service.icon}</span>
      </div>

      <div className="service-card__body">
        <p className="service-card__subtitle">{t(`services_data.${service.id}.subtitle`, service.subtitle).toUpperCase()}</p>
        <h3 className="service-card__title">{t(`services_data.${service.id}.title`, service.title)}</h3>
        <p className="service-card__desc">{t(`services_data.${service.id}.short`, service.short)}</p>
        <span className={`service-card__link ${hovered ? "service-card__link--active" : ""}`}>
          {t("services.learnMore")}
        </span>
      </div>
    </div>
  );
}

export default ServiceCard;
